import useAccountRestoration from 'store/authStore/useAccountRestoration';

// Reserve account controls from the first frame of session restoration. This is
// a layout hint only; actions still require the real account from the auth store.
const useSwapAccountLayout = () => useAccountRestoration().hasAccountLayout;

export default useSwapAccountLayout;
